import React from "react";
import { useColors } from "../contexts/ColorContext";

function Footer() {
  const { getClasses, colors } = useColors();

  return (
    <footer className={`${getClasses("secondary")} text-white py-12`}>
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between mb-12">
          <div className="mb-8 md:mb-0">
            <h3 className="text-2xl font-bold mb-4">Jambops Solutions</h3>
            <p className={`text-${colors.secondary}-200 max-w-xs`}>
              Ofreciendo soluciones eléctricas y digitales de alta calidad para
              satisfacer todas sus necesidades profesionales.
            </p>
          </div>

          <div className="mb-8 md:mb-0">
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#inicio"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Servicios
                </a>
              </li>
              <li>
                <a
                  href="#nosotros"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Nosotros
                </a>
              </li>
              <li>
                <a
                  href="#contacto"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div className="mb-8 md:mb-0">
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#servicios"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Instalaciones Eléctricas
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Electrónica Naval
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Desarrollo Web
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className={`text-${colors.secondary}-200 hover:text-white transition duration-300`}
                >
                  Infraestructura en la Nube
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2">
              <li className={`text-${colors.secondary}-200`}>
                info@jambops.com
              </li>
              <li className={`text-${colors.secondary}-200`}>
                comercial@instalacionestronat.com
              </li>
              <li className={`text-${colors.secondary}-200`}>
                Tel/WhatsApp: +34 648 71 56 45
              </li>
            </ul>
          </div>
        </div>

        <div
          className={`pt-8 border-t border-${colors.secondary}-800 text-center`}
        >
          <p className={`text-${colors.secondary}-200`}>
            &copy; {new Date().getFullYear()} Jambops Solutions. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
